// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__jvmhL","white":"styles_white__mOEUI"};